import { Icon } from "./Icon";
import { CONTACT } from "../site";

/** Barra fija de contacto en pantallas táctiles: siempre a un toque del pulgar. */
export function StickyCta() {
  return (
    <nav className="sticky-cta" aria-label="Contacto rápido">
      <a href={CONTACT.tel}>
        <Icon name="phone" />
        Llamar
      </a>
      <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer">
        <Icon name="whatsapp" />
        WhatsApp
      </a>
    </nav>
  );
}
